import React, { useState } from "react";
import RequestStatusCompany from "./RequestStatusCompany";
import RequestSelector from "./RequestSelector";

/**
 * 希望条件ステータスの共通入口コンポーネント
 *
 * viewerType に応じて表示用 / 操作用コンポーネントを切り替える。
 *
 * - company : 表示専用（ステータス確認のみ）
 * - user    : 操作可能（公開 / 非公開の切り替え）
 */
const RequestStatus = ({ viewerType, type, isActive, onToggle }) => {
  // 企業側は表示専用コンポーネントを返す
  if (viewerType === "company") {
    return <RequestStatusCompany type={type} />;
  }

  // ユーザー側は公開 / 非公開を操作できるUIを返す
  return <RequestSelector isActive={isActive} onToggle={onToggle} />;
};

export default RequestStatus;
